export const RESET_STATE = 'RESET_STATE';
export const SET_CRT_INTERNAL_ID = 'SET_CRT_INTERNAL_ID';
export const SET_FETCH_NOTARY_CERTIFICATE_STATUS = 'SET_FETCH_NOTARY_CERTIFICATE_STATUS';
export const SET_CALCULATE_MERKLE_TREE_ROOT_STATUS = 'SET_CALCULATE_MERKLE_TREE_ROOT_STATUS';
export const SET_MERKLE_TREE_ROOT = 'SET_MERKLE_TREE_ROOT';
export const SET_JSON_ID = 'SET_JSON_ID';
export const SET_CRT_HASH_ROOT = 'SET_CRT_HASH_ROOT';
export const SET_VALIDATE_HASH_STATUS = 'SET_VALIDATE_HASH_STATUS';
export const SET_CALCULATE_CRT_ID_STATUS = 'SET_CALCULATE_CRT_ID_STATUS';
export const SET_CALCULATED_CRT_ID = 'SET_CALCULATED_CRT_ID';
export const SET_VALIDATE_MERKLE_STATUS = 'SET_VALIDATE_MERKLE_STATUS';
export const SET_ITEM_HASH = 'SET_ITEM_HASH';
export const SET_HASH_LIST = 'SET_HASH_LIST';
export const SET_MERKLE_PROOF = 'SET_MERKLE_PROOF';
export const SET_HASH_ROOT = 'SET_HASH_ROOT';
export const SET_MERKLE_ROOT = 'SET_MERKLE_ROOT';
export const SET_TRANSACTION_ID = 'SET_TRANSACTION_ID';
export const SET_DISPLAY_FILE_NAME = 'SET_DISPLAY_FILE_NAME';
export const SET_CRT_DATE = 'SET_CRT_DATE';
export const SET_SIGNEE = 'SET_SIGNEE';
export const SET_SPL_ITEM_HASH = 'SET_SPL_ITEM_HASH';
